import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_134: DocMigration = {
  maxSchemaVersion: "0.0.134",
  description: "New default values for truncation slopes.",
  apply(json: any) {
    const { settings: allSettings, roofs, dormers } = json;

    // roof settings
    for (const settingsId in allSettings) {
      const settings = allSettings[settingsId];
      if (settings.type !== "ROOF_SETTINGS") {
        continue;
      }

      if (settings.startTruncationSlopeType === undefined) {
        settings.startTruncationSlopeType = settings.startTruncationSlope !== undefined ? "OVERRIDE" : "FROM_HOST";
      }

      if (settings.endTruncationSlopeType === undefined) {
        settings.endTruncationSlopeType = settings.endTruncationSlope !== undefined ? "OVERRIDE" : "FROM_HOST";
      }
    }

    // roof instances
    for (const roofId in roofs) {
      const { roofSettings = {} } = roofs[roofId];

      if (roofSettings.startTruncationSlopeType === undefined) {
        roofSettings.startTruncationSlopeType =
          roofSettings.startTruncationSlope !== undefined ? "OVERRIDE" : "FROM_HOST";
      }

      if (roofSettings.endTruncationSlopeType === undefined) {
        roofSettings.endTruncationSlopeType = roofSettings.endTruncationSlope !== undefined ? "OVERRIDE" : "FROM_HOST";
      }
    }

    // dormers
    for (const dormerId in dormers) {
      const dormer = dormers[dormerId];

      if (dormer.truncationOptions === undefined) {
        dormer.truncationOptions = { slopeType: "OVERRIDE" };
      } else if (dormer.truncationOptions.slopeType === undefined) {
        dormer.truncationOptions.slopeType = "OVERRIDE";
      }
    }

    return json;
  },
};

export default migration_0_0_134;
